export const fillTransition = 'fill .3s ease-in-out';
export const opacityTransition = 'opacity .3s ease-in-out';
export const strokeWidthTransition = 'stroke-width .3s ease-in-out';

export const DEEMPHASIZED_OPACITY = 0.3;
